import { Content } from '../../types/tour';

export const content: Content[] = [
  {
    title: 'Try the Chat Messaging API',
    paragraphs: [
      "In this interactive tutorial, we’ll show you the core concepts of the <strong>Chat Messaging API</strong>. If you haven’t seen our <a href='https://getstream.io/chat/sdk/react/'>React Chat Components</a> yet, you’ll want to give this tutorial a try first.",
    ],
  },
  {
    title: 'Setup a connection',
    paragraphs: [
      "Ok, so we're going to build a Messaging style chat. Let's get started by connecting to Stream",
    ],
    blockquotes: [
      'In the code above we connect to Stream and set the current user to “USER_NAME“.',
    ],
  },
  {
    title: 'Create a Channel',
    paragraphs: [
      "With the client set up, you'll want to create a channel with members:",
      'The first argument is the <strong>channel type</strong>. Different channel types can have different features enabled and different permissions.',
      'The second argument is the <strong>ID of the conversation</strong> – it is optional, if you leave it out we will generate an ID based on the list of members.',
      'The third argument is an <strong>object with all the data</strong> for this channel. You can use this to store any custom metadata about this channel. Name and image are displayed by the Chat React components by default. The members list is special – it allows you to restrict a conversation to a list of specific members. The permissions these members have is configurable per channel type via the Dashboard.',
    ],
    blockquotes: [
      '<em>Note:</em> <code>channel.watch()</code> retrieves the current channel state (messages, members, read events etc.) and also ensures your current WebSocket connection listens to changes on this channel.',
    ],
  },
  {
    title: 'Send a Message',
    paragraphs: [
      'Now that we have a channel up and runnning you can add a message to the channel like this:',
      "Ok, so we're going to build a Messaging style chat. Let's get started by connecting to Stream",
      'Messages are displayed in real-time within the UI on the right. Run the code below to see a message with a rich video preview. Similar to users and channels, messages also allow you to attach custom data if needed.',
    ],
    blockquotes: [
      "<em>Note:</em> The display on the right is using our standard <a href='https://getstream.io/chat/sdk/react/'>React Chat components</a>. You don’t need to use these components, but they provide a convenient and flexible starting point.",
      '<em>Note:</em> The message is displayed in real-time within the UI on the right. The provided URL is shown with a rich video preview. Similar to users and channels, messages also allow you to attach custom data if needed.',
    ],
  },
  {
    title: 'Add a Reaction',
    paragraphs: [
      'If you’re familiar with Facebook Messenger you’ll know the concept of reacting to a message. Below shows an example of how to like a message.',
    ],
    blockquotes: [
      "<em>Note:</em> When reading a channel you'll receive the reaction count for each message.",
    ],
  },
  {
    title: 'Start a Thread',
    paragraphs: [
      'For team style use cases such as Slack you’ll want to support replies and threads. You can create a thread of messages by specifying a <code>parent_id</code> on a new message:',
    ],
    blockquotes: [
      "<em>Note:</em> When reading a channel you'll receive the reaction count for each message.",
    ],
  },
  {
    title: 'State & Listen to Events',
    paragraphs: [
      "So far we've been relying on the pre-made UI components. If you're building your own UI components you'll want to listen to the Chat events directly. Have a look at how to intercept the message.new event, and send a new message:",
    ],
  },
];
